import {
  UPDATE_CONTRACTED_HOURS_SUCCESS,
  UPDATE_CONTRACTED_HOURS_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case UPDATE_CONTRACTED_HOURS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case UPDATE_CONTRACTED_HOURS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
